import fr from '../translations/fr'
import en from '../translations/en'
import zu from '../translations/zu'
import SETTINGS from '@/src/settings'

// Reproduit apollo/server/resolvers/Translations/getTranslations.ts (sans eval, sans reseau).
// fr -> fr, en -> en, SETTINGS.intlAdmin.lang_code ('zu') -> zu, defaut -> SETTINGS.localeDefault.
const TRANSLATIONS: Record<string, Record<string, string>> = {
  fr,
  en,
  [SETTINGS.intlAdmin.lang_code]: zu,
}

export const getTranslations = (locale?: string): Record<string, string> => {
  if (locale && TRANSLATIONS[locale]) return TRANSLATIONS[locale]
  return TRANSLATIONS[SETTINGS.localeDefault] ?? fr
}
